/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_SD_APPLICATIONS } from './actionTypes';

import { postSdApplicationsUtil } from './utils';

/**
 * Contains the action creator functions that update the SDApplicationForm slice of the store.
 *
 * @namespace SDApplicationFormActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sd_applications
   *
   * @param {NewUAApplicationCreationDetails} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof SDApplicationFormActions
   */
  static postSdApplications = (dispatch, newUAApplicationCreationDetails, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      postSdApplicationsUtil.bind(null, newUAApplicationCreationDetails),
      POST_SD_APPLICATIONS,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postSdApplications.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof SDApplicationFormActions
   */
  static resetPostSdApplications = (dispatch, data) => {
    const json = {
      type: POST_SD_APPLICATIONS.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postSdApplications.
   *
   * @param {function} dispatch
   * @function
   * @memberof SDApplicationFormActions
   */
  static resetPostSdApplicationsError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, POST_SD_APPLICATIONS.failureAction);
  };
}
